/* eslint-disable no-param-reassign */
import isEqual from 'lodash/isEqual';
import { Area, Point, PrstTxWarp } from '../type/common.interface';
import { affineTransform } from './core/affine-transform/affine-transform';
import { transformLinesRouter } from './core/transform-line/transform-lines-router';
import { getLinePointsInArea } from './utils/get-line-points-in-area';

export class PrstTransform {
    public static instance: PrstTransform;

    public static getInstance() {
        if (!this.instance) {
            this.instance = new PrstTransform();
        }
        return this.instance;
    }

    private transformLinePointsListMap = new Map<number, Point[][]>();
    private prstTxWarpAvLstMap = new Map<number, any>();

    public setTransformLinesPoints(prstTxWarp: PrstTxWarp, area: Area) {
        if (isEqual(this.prstTxWarpAvLstMap.get(prstTxWarp.prst), { ...prstTxWarp.avLst, ...area })) return;
        this.prstTxWarpAvLstMap.set(prstTxWarp.prst, { ...prstTxWarp.avLst, ...area });

        const transformLines = transformLinesRouter(prstTxWarp, area);

        const transformLinePointsList: Point[][] = [];

        transformLines.forEach((line) => {
            transformLinePointsList.push(getLinePointsInArea(line, area));
        });

        this.transformLinePointsListMap.set(prstTxWarp.prst, transformLinePointsList);
    }

    public getTransformLinesPoints = (prstTxWarp: PrstTxWarp): Point[][] | undefined =>
        this.transformLinePointsListMap.get(prstTxWarp.prst);

    public getTransformedPoint(prstTxWarp: PrstTxWarp, area: Area, point: Point) {
        const transformLinePointsList = this.transformLinePointsListMap.get(prstTxWarp.prst);
        if (!transformLinePointsList?.length) {
            return point;
        }

        const [bottomLinePoints, topLinePoints] = transformLinePointsList;

        point.x -= area.offset.x;
        point.y -= area.offset.y;

        const { x, y } = affineTransform(area, point, bottomLinePoints, topLinePoints);

        return { x: x + area.offset.x, y: y + area.offset.y };
    }
}
